<template>
  <div style="
      
        position:absolute;
        left:0;top:0;bottom:0;right:0;overflow-y:scroll;
      margin-left:1rem;margin-top:2rem">
    <v-container>

      <v-expansion-panel style="margin-bottom:1rem" class="text-xs-left">
      <v-expansion-panel-content class="text-xs-left">
        <template v-slot:header>
          <v-layout  align-center class="text-xs-left" style="margin:-1rem;margin-left:0">
          <v-flex xs1>
                <img style="width:40%;margin-left:-1rem;padding-top:0.2rem" src="@/assets/technology/lora.png"/>
          </v-flex>
          <v-flex xs11 >FP-ATR-LORA1</v-flex>
          </v-layout>
        </template>
        <lora style="padding:3rem"></lora>
      </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-bottom:1rem" class="text-xs-left">
      <v-expansion-panel-content class="text-xs-left">
        <template v-slot:header>
          <v-layout  align-center class="text-xs-left" >
          <v-flex xs1>
                <img style="width:40%;" src="@/assets/technology/sigfox.png"/>
          </v-flex>
          <v-flex xs11 >FP-ATR-SIGFOX1</v-flex>
          </v-layout>
        </template>
        <sigfox style="padding:3rem" ></sigfox>
      </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-bottom:1rem" class="text-xs-left">
      <v-expansion-panel-content class="text-xs-left">
        <template v-slot:header>
          <v-layout  align-center class="text-xs-left" >
          <v-flex xs1>
                <img style="width:20%;" src="@/assets/technology/lte.png"/>
          </v-flex>
          <v-flex xs11 >FP-ATR-LTE1</v-flex>
          </v-layout>
        </template>
        <lte style="padding:3rem"></lte>
      </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-bottom:1rem" class="text-xs-left">
      <v-expansion-panel-content class="text-xs-left">
        <template v-slot:header>
          <v-layout  align-center class="text-xs-left" >
          <v-flex xs1>
                <img style="width:10%;" src="@/assets/technology/bluetooth.png"/>
          </v-flex>
          <v-flex xs11 >FP-ATR-BLE1</v-flex>
          </v-layout>
        </template>
      </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-bottom:1rem" class="text-xs-left">
      <v-expansion-panel-content class="text-xs-left">
        <template v-slot:header>
          <v-layout  align-center class="text-xs-left" >
          <v-flex xs1>
                <img style="width:30%;;margin-left:-0.5rem" src="@/assets/technology/nfc.png"/>
          </v-flex>
          <v-flex xs11 >FP-SNS-SMARTAG1</v-flex>
          </v-layout>
        </template>
      </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel style="margin-bottom:1rem" class="text-xs-left">
      <v-expansion-panel-content class="text-xs-left">
        <template v-slot:header>
          <v-layout  align-center class="text-xs-left" >
          <v-flex xs1>
                <img style="width:20%;" src="@/assets/technology/wifi.png"/>
          </v-flex>
          <v-flex xs11 >X-CUBE-AWS1, FP-CLD-AWS1</v-flex>
          </v-layout>
        </template>
        <wifi style="padding:3rem"></wifi>
      </v-expansion-panel-content>
      </v-expansion-panel>
    </v-container>
  </div>
</template>

<script>
import lora from './content-components/HowToLoRa'
import sigfox from './content-components/HowToSigfox'
import lte from './content-components/HowToLte'
import wifi from './content-components/HowToWifi'
export default {
    components:{
        lora,
        wifi,
        sigfox,
        lte
    }
}
</script>>